export const LOCK_TOOLTIP_TEXT =
  "Los precios se están calculando automáticamente. Por favor, espera a que termine el cálculo.";
export const RECALC_IN_PROGRESS_MSG =
  "Los precios se están calculando automáticamente. Espera a que termine e inténtalo de nuevo.";
export const TTF_RECALCULATED_MSG =
  "Los precios han sido recalculados automáticamente desde que abriste el editor. Los cambios han sido descartados.";
export const CONCURRENT_MODIFICATION_MSG =
  "Otro usuario o un proceso automático ha modificado estos precios. Los cambios han sido descartados.";
export const MARKET_PRICE_EXISTS_MSG =
  "No se puede guardar un precio anticipado sobre instrumentos que ya tienen precio de mercado real.";
export const DEFAULT_SAVE_ERROR_MSG = "Error al guardar precios.";
export const REASON_RECALC_IN_PROGRESS = "recalc_in_progress";
export const REASON_TTF_RECALCULATED = "ttf_recalculated";
export const REASON_CONCURRENT_MODIFICATION = "concurrent_modification";
export const REASON_MARKET_PRICE_EXISTS = "market_price_exists";